import { array, object, string } from 'yup';

export default object({
  data: array().of(
    object({
      title: string().required()
    })
  )
}).required();
